module.exports = "https://static.wmbcdn.com/uniweb/images/cc43798c8ea9fca1f6c89143a3d0d537.svg";